module.exports = __webpack_public_path__ + "h5/img/mfe_13.3162fefc.jpg";